import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import './assets/images/fontawesome'
import App from './pages/App';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider } from 'react-redux';
import store, { history, persistor } from './store';
import { ConnectedRouter as ConnectedRouterProvider } from 'connected-react-router';
import { ThemeProvider } from '@mui/styles';
import theme from './materialUIStyleOverrides';
import { PersistGate } from 'redux-persist/integration/react';
import { SnackbarProvider } from 'notistack';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

if (process.env.NODE_ENV !== 'production') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}

dayjs.extend(utc);
dayjs.extend(timezone);

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <SnackbarProvider autoHideDuration={4000}>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ConnectedRouterProvider history={history}>
                        <App />
                    </ConnectedRouterProvider>
                </PersistGate>
            </ReduxProvider>
        </SnackbarProvider>
    </ThemeProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
